import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import DocViewer from "@cyntler/react-doc-viewer";
import { DocViewerRenderers } from "../common/DocViewerRenderers";
import { Unsupported } from "../common/UnsupportedRenderer";

interface DocumentPreviewerProps {
  open: boolean;
  setOpen: (arg: boolean) => void;
  title: string;
  documentUri?: string;
}

export const DocumentPreviewer = ({
  open,
  setOpen,
  title,
  documentUri,
}: DocumentPreviewerProps) => {
  const handleOpenChange = () => setOpen(!open);

  if (!documentUri) {
    return (
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div className="p-4 text-center">
              <p>No Attachment</p>
            </div>
          </DialogBody>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody className="flex flex-col h-[70vh]">
          <div className="grow w-full relative h-0 overflow-hidden">
            {documentUri && (
              <DocViewer
                prefetchMethod="GET"
                pluginRenderers={DocViewerRenderers}
                documents={[{ uri: documentUri }]}
                config={{
                  header: {
                    disableHeader: true,
                  },
                  noRenderer: {
                    overrideComponent: ({ document }) => {
                      return <Unsupported url={document?.uri} />;
                    },
                  },
                  loadingRenderer: {
                    overrideComponent: ({ document, fileName }) => {
                      const fileText = fileName || document?.fileType || "";
                      return (
                        <div className="text-center p-2 truncate">
                          Loading
                          {fileText && (
                            <>
                              <br />({fileText})
                            </>
                          )}
                        </div>
                      );
                    },
                  },
                  csvDelimiter: ",",
                  pdfZoom: {
                    defaultZoom: 1.0,
                    zoomJump: 0.2,
                  },
                  pdfVerticalScrollByDefault: true,
                }}
              />
            )}
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
